window.$ &&
  $(document).ready(function () {
    instagramGalleryMethod();
    jdgmCarouselArrow();
    klarnaModal();
    footerMenuMobile();
    $('.instagram_product_handle').each(function () {
      var product_handle_str = $(this).attr('data');
      var product_info = getProductInfo(
        product_handle_str,
        $(this),
        getInstagramProductInfo
      );
    });
    $(document).on('click', '.coupon-copy-btn', function (e) {
      copyMethod($(this).attr('data'));
      $(this).text('Copied');
    });
    if ($('#product_spu_title').length) {
      ajaxGetSections(
        'template--23903498371314__section_instagram_gallery_page_VBV6Qc&handles=' +
          $('#product_spu_title').attr('product_handle'),
        $('.shopify-app-block[id*=judge_me_reviews_review_widget]').parents(
          '.shopify-section'
        ),
        getProductnstagram
      );
    }
    getRecentlyViewedProducts();
    ajaxAddCartByForm('form.compare-form-cart');
    setTimeout(function () {
      instagramProductHandle();
    }, 2500);
    $(document)
      .on('click', '.apply-discount-btn', function (e) {
        e.preventDefault();
        applyDiscount(
          $(this)
            .parent('.cart-sidebar-discount')
            .find('#discount-code-input')
            .val()
        );
      })
      .on(
        'click',
        '.applied-discount-code .applied-discount-code-wrapper,#clear-discount-btn',
        function (e) {
          e.preventDefault();
          let current_code = $(this).attr('data');
          clearDiscount(current_code);
        }
      );
    if ($('.shopify-section--judge-reviews-carousel').length) {
      $('.jdgm-carousel__left-arrow') /*.attr('aria-label', 'Previous review')*/
        .html(
          '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>'
        );
      $('.jdgm-carousel__right-arrow') /*.attr('aria-label', 'Next review')*/
        .html(
          '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg>'
        );

      // Judge.me carousel markup often ships with an inline style that hides it until their JS initializes.
      // In theme dev / preview this can stay hidden; remove the hide style as a safe fallback.
      $('.shopify-section--judge-reviews-carousel .jdgm-carousel style').each(
        function () {
          const cssText = $(this).text() || '';
          if (
            cssText.indexOf('.jdgm-carousel') !== -1 &&
            cssText.indexOf('display') !== -1 &&
            cssText.indexOf('none') !== -1
          ) {
            $(this).remove();
          }
        }
      );
      $('.shopify-section--judge-reviews-carousel .jdgm-carousel').css(
        'display',
        'block'
      );

      $('.jdgm-carousel-item__review-wrapper').each(function () {
        let item_reviewer_name = $(this).find(
          '.jdgm-carousel-item__reviewer-name'
        );
        $(this)
          .find('.jdgm-carousel-item__review-rating')
          .before(item_reviewer_name);
        //item_reviewer_name.remove();
        $(this).after(
          $(this).find('.jdgm-carousel-item__reviewer-name-wrapper')
        );
        $(this).find('.jdgm-carousel-item__reviewer-name-wrapper').remove();
      });
      $('.jdgm-carousel-item__product.jdgm-ellipsis').each(function () {
        $(this).attr(
          'href',
          $(this).attr('href').replace('#judgeme_product_reviews', '')
        );
        let product_handle_str = $(this).attr('href');
        product_handle_str = product_handle_str.replace('/products/', '');
        getProductInfo(product_handle_str, $(this), showProductThumbnail);
      });
    }
    getShippingRate();
  });
//window.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  var value = '',
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || this.money_format;

  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var slickDom = null;
function instagramGalleryMethod() {
  // 相册页面功能
  if ($('.section-instagram-gallery').length <= 0) {
    return;
  }
  $(document).on('click', '.image-list-item', function () {
    let indexData = $(this).find('.img-box').attr('index');
    slickDom.slick('slickGoTo', Number(indexData) - 2);
    const curDom = $('.image-list-slick-modal .image-list-item-video');
    for (let i = 0; i < curDom.length; i++) {
      curDom[i].addEventListener('pause', function () {
        $(curDom[i]).siblings('.video-icon').show();
      });
      curDom[i].addEventListener('play', function () {
        $(curDom[i]).siblings('.video-icon').hide();
        const curDom1 = $('.image-list-slick-modal .image-list-item-video');
        for (let i = 0; i < curDom1.length; i++) {
          const curClass = $(curDom1[i]).parent().attr('class');
          if ($(curDom1[i]) && $(curDom1[i]).length > 0) {
            if (curClass.indexOf('slick-active') == 0) {
              $(curDom1[i])[0].pause();
            }
          }
        }
      });
      curDom[i].addEventListener('ended', function () {
        $(curDom[i]).siblings('.video-icon').show();
      });
    }
    setTimeout(function () {
      $('.image-list-slick-modal .video-icon').show();
      const modalWidth = $('.image-list-slick-modal')
        .find('.slick-track')
        .width();
      if ($(window).width() < 990 && modalWidth < 50) {
        $('.image-list-slick-modal')
          .find('.slick-track')
          .css('width', $(window).width() + 'px');
        $('.image-list-slick-modal')
          .find('.img-box')
          .css('width', $(window).width() + 'px');
      }
    }, 800);
    $('body').addClass('cartover');
    $('.image-list-slick-modal').show();
  });
  $(document).on('click', '.slick-modal-mask-close', function () {
    $('.image-list-slick-modal').hide();
    $('body').removeClass('cartover');
    pauseVideo();
  });

  $('.image-list-slick-modal .slick-modal-mask-close').on(
    'touchend',
    function (e) {
      $('.image-list-slick-modal').hide();
      $('body').removeClass('cartover');
      pauseVideo();
      e.preventDefault();
    }
  );
  $(document).on('click', '.image-list-slick-modal .video-icon', function () {
    pauseVideo();
    const $domVideo = $(this).siblings('video');
    if ($domVideo && $domVideo.length > 0) {
      $domVideo[0].play();
      $(this).hide();
    }
  });
  $(document).on(
    'click',
    '.section-instagram-gallery .next-slide',
    function (e) {
      pauseVideo();
      if (e && e.preventDefault) {
        e.preventDefault();
      } else {
        window.event.returnValue = false;
      }
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
      return false;
    }
  );
  $(document).on(
    'click',
    '.section-instagram-gallery .prev-slide',
    function (e) {
      pauseVideo();
      if (e && e.preventDefault) {
        e.preventDefault();
      } else {
        window.event.returnValue = false;
      }
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
      return false;
    }
  );
  function pauseVideo() {
    const curDom = $('.image-list-slick-modal .image-list-item-video');
    for (let i = 0; i < curDom.length; i++) {
      if ($(curDom[i]) && $(curDom[i]).length > 0) {
        $(curDom[i])[0].pause();
      }
    }
  }
  var $modalSlick = $('.image-list-slick-modal .image-list-slick');
  if ($modalSlick.length && !$modalSlick.hasClass('slick-initialized')) {
    slickDom = $modalSlick.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: isAppleMobile() ? false : true,
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      centerPadding: 0,
      initialSlide: 0,
      //prevArrow:'<span class="prev-slide" aria-label="Previous slide"><i class="fa fa-angle-left"></i></span>',
      //nextArrow:'<span class="next-slide" aria-label="Next slide"><i class="fa fa-angle-right"></i></span>',
      prevArrow:
        '<span class="prev-slide" aria-label="Previous slide"><svg fill="none" width="16" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
      nextArrow:
        '<span class="next-slide" aria-label="Next slide"><svg fill="none" width="16" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
      focusOnSelect: false,
      swipe: isAppleMobile() ? false : true,
      //lazyLoad:'ondemand'
    });
  }
  var $galleryList = $('.js_section_instagram_gallery .image-list');
  if ($galleryList.length && !$galleryList.hasClass('slick-initialized')) {
    $galleryList.slick({
      slidesToShow: $(window).width() > 990 ? 4 : 1,
      slidesToScroll: $(window).width() > 990 ? 4 : 1,
      dots: false,
      arrows: true,
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      centerPadding: 0,
      //prevArrow:'<button type="button" class="prev-slide" aria-label="Previous slide"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      //nextArrow:'<button type="button" class="next-slide"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      prevArrow:
        '<button type="button" class="prev-slide" aria-label="Previous slide"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
      nextArrow:
        '<button type="button" class="next-slide" aria-label="Next slide"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
      focusOnSelect: false,
      initialSlide: 0,
      //lazyLoad:'ondemand',
    });
  }
  var $galleryIndexList = $('.js_section_instagram_gallery_index .image-list');
  if (
    $galleryIndexList.length &&
    !$galleryIndexList.hasClass('slick-initialized')
  ) {
    $galleryIndexList.slick({
      slidesToShow: $(window).width() > 990 ? 1.01 : 1.03,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: true,
      centerPadding: $(window).width() > 990 ? 0 : '0px',
      prevArrow:
        '<button type="button" class="prev-slide" aria-label="Previous slide"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      nextArrow:
        '<button type="button" class="next-slide" aria-label="Next slide"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      //prevArrow:'<button type="button" class="prev-slide" aria-label="Previous slide"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
      //nextArrow:'<button type="button" class="next-slide" aria-label="Next slide"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
      focusOnSelect: false,
      initialSlide: 0,
      adaptiveHeight: false,
      //lazyLoad:'ondemand',
    });
  }
  if (slickDom) {
    slickDom.on('afterChange', function (e, slick, currentSlide) {
      if (e && e.preventDefault) {
        e.preventDefault();
      } else {
        window.event.returnValue = false;
      }
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
    });
  }
  // const height1 = $('.image-list-item').width();
  // $(".image-list-item .img-box img").css('height', height1+'px');
  // $(".image-list").css('opacity', 1);
  const height1 = $('.image-list-item').width()
    ? $('.image-list-item').width()
    : $(window).width() / 2;
  const isHaveClassDom = $(
    '.section-instagram-gallery .js_section_instagram_gallery_index'
  );
  if (isHaveClassDom.length > 0) {
    $('.image-list-item .img-box img').css('height', height1 / 2 + 'px');
    const isPc = $(window).width() > 990 ? true : false;
    const imageDom = $('.image-list-item-outer');
    for (let i = 0; i < imageDom.length; i++) {
      const firstDom = $(imageDom[i]).children().eq(0); //第一个元素
      if (isPc) {
        firstDom.find('.img-box img').css('height', height1 + 20 + 'px');
      } else {
        firstDom.find('.img-box img').css('height', height1 + 10 + 'px');
      }
    }
  } else {
    $('.image-list-item .img-box img').css('height', height1 + 'px');
  }
  $('.image-list').css('opacity', 1);
}
// 是否为 iPhone
function isAppleMobile() {
  return navigator.platform.indexOf('iPhone') != -1;
}
function jdgmCarouselArrow() {
  const container = $('.jdgm-container .jdgm-carousel__arrows');
  const leftArrow = container.find('.jdgm-carousel__left-arrow');
  const rightArrow = container.find('.jdgm-carousel__right-arrow');
  const arrowDom1 = container.find('.jdgm-carousel__left-arrow .fa-arrow-left');
  const arrowDom2 = container.find(
    '.jdgm-carousel__right-arrow .fa-arrow-right'
  );
  arrowDom1.length == 0 &&
    leftArrow.append(
      `<svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg>`
    );
  arrowDom2.length == 0 &&
    rightArrow.append(
      `<svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg>`
    );
}
function getProductnstagram(section_filename, ele_obj, data) {
  console.log('data', data);
  console.log('section_filename112', section_filename);
  var section_filename_list = section_filename.split('&');
  if (section_filename_list.length >= 1) {
    var section_filename_arr = section_filename_list[0].split(',');
    console.log('section_filename_arr23', section_filename_arr);
    let current_product_sku_ele = $('#product_spu_title');
    let current_product_handle = current_product_sku_ele.attr('product_handle');
    let current_product_sku_ele_all = $('#current-product-all-sku');
    if (current_product_sku_ele.length) {
      for (var i = 0; i < section_filename_arr.length; i++) {
        if (
          typeof data[section_filename_arr[i]] != 'undefined' &&
          data[section_filename_arr[i]]
        ) {
          var product_handle_contain = 0;
          let $res_html = $(data[section_filename_arr[i]]);
          console.log('res_html23', $res_html);
          let img_box_index1 = 0;
          $res_html.find('.instagram_product_handle').each(function () {
            var product_handle_str = $(this).attr('product_handle');
            var product_handle_spu = $(this).attr('spuattr');
            if (product_handle_spu != '') {
              if (current_product_sku_ele_all.hasClass(product_handle_spu)) {
                product_handle_contain = 1;
                $(this)
                  .attr('data', current_product_sku_ele_all.html())
                  .attr(
                    'product_url',
                    '/products/' + current_product_sku_ele_all.html()
                  );
                //$res_html.find('div[ product_handle="'+product_handle_str+'"]').attr('product_handle', product_handle_str+'|'+current_product_sku_ele_all.html());
              }
            }

            if (product_handle_str != '') {
              if (product_handle_str.indexOf(current_product_handle) === -1) {
                $res_html.find($(this).parents('.img-box')).remove();
              } else {
                product_handle_contain = 1;
                $(this).parents('.img-box').attr('index', ++img_box_index1);
              }
            }
          });

          if (product_handle_contain) {
            var img_box_index = 0;
            $res_html.find('.image-list .image-list-item').each(function () {
              let item_product_handle = $(this).attr('product_handle');
              if (item_product_handle != '') {
                if (
                  item_product_handle.indexOf(current_product_handle) === -1
                ) {
                  $res_html.find($(this)).remove();
                } else {
                  $(this).find('.img-box').attr('index', ++img_box_index);
                }
              }
            });
            console.log('---');
            console.log($res_html.html());
            ele_obj.before($res_html);
            if ($('.instagram_product_handle').length > 0) {
              // $('.engoj_find_img_div.instagram_product_handle').each(function() {
              //   var product_handle_str = $(this).attr('data');
              //   var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
              // });
              //$('.section-instagram-gallery .instagram_gallery_title').html('Find #Sedeta In Media');
              instagramProductHandle();
              instagramGalleryMethod();
            }
          }
        }
      }
    }
  }
}
function ajaxGetSections(section_filename, ele_obj, callback) {
  if (section_filename && ele_obj && callback) {
    $.ajax({
      url: '/?sections=' + section_filename,
      type: 'GET',
      dataType: 'json',
      cache: false,
      success: function (data) {
        callback(section_filename, ele_obj, data);
      },
      error: function (data) {
        console.log('section', data);
      },
    });
  }
}
function getProductInfo(product_handle, ele_obj, callback) {
  if (product_handle) {
    try {
      jQuery.ajax({
        dataType: 'json',
        url: '/products/' + $.trim(product_handle) + '.js',
        cache: false,
        success: function (data) {
          callback && callback(ele_obj, data);
        },
        error: function () {},
      });
    } catch (e) {
      console.log(e);
    }
  }
}
function instagramProductHandle() {
  if ($('.instagram_product_handle .jdgm-badge-placeholder').length) {
    var data;
    data = $.map($('.jdgm-badge-placeholder'), function (element) {
      var hash = {};
      var $element = $(element);
      hash['productHandle'] = $element.data('handle');
      hash['badgePlaceholder'] =
        '.jdgm-badge-placeholder[data-handle="' +
        $element.data('handle') +
        '"]';
      return hash;
    });
    var checkBatchRenderBadges = setInterval(function () {
      if (
        typeof jdgm !== 'undefined' &&
        typeof jdgm.batchRenderBadges === 'function'
      ) {
        jdgm.batchRenderBadges(data);
        clearInterval(checkBatchRenderBadges);
        console.log('batchRenderBadges ok');
      } else {
        console.log('batchRenderBadges error');
      }
    }, 100);
  }
  $('.instagram_product_handle').each(function () {
    var product_handle_str = $(this).attr('data');
    var v_index_of = product_handle_str.indexOf('?');
    if (v_index_of > 0) {
      product_handle_str = product_handle_str.substr(0, v_index_of);
    }
    var product_info = getProductInfo(
      product_handle_str,
      $(this),
      getInstagramProductInfo
    );
  });
}
function getInstagramProductInfo(ele_obj, product_info) {
  if (
    ele_obj &&
    ele_obj.length &&
    product_info &&
    typeof product_info.featured_image != 'undefined' &&
    product_info.featured_image
  ) {
    if (product_info.variants.length > 0) {
      let show_variant_index = 0;
      for (
        variants_i = 0;
        variants_i < product_info.variants.length;
        variants_i++
      ) {
        if (product_info.variants[variants_i].available) {
          show_variant_index = variants_i;
          break;
        }
      }
      let show_current_handle = $(ele_obj).attr('data');
      for (
        variants_i = 0;
        variants_i < product_info.variants.length;
        variants_i++
      ) {
        if (
          product_info.variants[variants_i].available &&
          show_current_handle.indexOf(product_info.variants[variants_i].id) !=
            -1
        ) {
          show_variant_index = variants_i;
          break;
        }
      }
      $(ele_obj)
        .find('input[name="id"]')
        .val(product_info.variants[show_variant_index].id);
      $(ele_obj).find('input[name="product-id"]').val(product_info.id);
      $(ele_obj)
        .find('.engoj_find_right_title')
        .html(product_info.variants[show_variant_index].name);
      $(ele_obj)
        .find('a')
        .attr('href', product_info.url)
        .attr('title', product_info.title);
      $(ele_obj)
        .find('img.img-responsive')
        .attr('src', product_info.featured_image + '&width=200')
        .attr('title', product_info.title)
        .attr('alt', product_info.featured_image.alt);
      if (product_info.compare_at_price == null) {
        $(ele_obj)
          .find('span.price')
          .html(Shopify.formatMoney(product_info.price, window.money_format));
      } else {
        $(ele_obj)
          .find('span.price')
          .html(Shopify.formatMoney(product_info.price, window.money_format));
        $(ele_obj)
          .find('s.price-old')
          .html(
            Shopify.formatMoney(
              product_info.compare_at_price,
              window.money_format
            )
          );
      }
    }
  }

  if (
    ele_obj &&
    ele_obj.length &&
    product_info &&
    product_info.variants.length >= 1
  ) {
    $(ele_obj)
      .attr('product_id', product_info.id)
      .attr('variant_id', product_info.variants[0].id);
  }
}
function ajaxAddCartByForm(form_selector) {
  $(form_selector).on('submit', function (event) {
    event.preventDefault(); // prevent default form submission
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function (line_item) {
        console.log(12, line_item);
        let mycart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        if (typeof line_item != 'undefined') {
          mycart.renderContents(line_item);
          if (mycart && mycart.classList.contains('is-empty'))
            mycart.classList.remove('is-empty');
        }
      },
      error: function (data) {
        console.log(22, data);
      },
    });
  });
}
function copyMethod(spu_no) {
  try {
    const newInput = document.createElement('input');
    newInput.value = spu_no;
    document.body.appendChild(newInput);
    newInput.select();
    document.execCommand('Copy');
    newInput.remove();
    showCustomModal();
  } catch (e) {
    console.log(e);
  }
}
function showCustomModal() {
  setTimeout(function () {
    hideCustomModal();
  }, 2000);
}
function hideCustomModal() {
  $('.ant-message').css('display', 'none');
  $('.coupon-copy-btn').text('Copy');
}

function klarnaModal() {
  $(document).on(
    'click',
    '.klarna-message-model .klarna-message-model-payment-close',
    function (e) {
      $('.klarna-message-model').css('display', 'none');
      $('body').removeClass('cartover');
    }
  );

  $(document).on(
    'click',
    '.klarna-message-model .payment-close-span',
    function (e) {
      $('.klarna-message-model').css('display', 'none');
      $('body').removeClass('cartover');
    }
  );

  $(document).on(
    'click',
    '.klarna-message-block-view .klarna-message-link',
    function (e) {
      $('.klarna-message-model')
        .css('display', 'flex')
        .css('width', $(window).width())
        .css('height', $(window).height());
      $('body').addClass('cartover');
    }
  );
}

function setCookie(name, value, hours) {
  // 设置cookie
  var d = new Date();
  d.setTime(d.getTime() + hours * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function getCookie(name) {
  // 读取cookie
  var cname = name + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(cname) === 0) {
      return c.substring(cname.length, c.length);
    }
  }
  return '';
}

function getRecentlyViewedProducts() {
  let recentlyViewEle = $('#recently-viewed-block');
  if (recentlyViewEle.length <= 0) {
    return;
  }
  let c_product_id = parseInt(recentlyViewEle.data('product-id'));
  const items = JSON.parse(
    localStorage.getItem('theme:recently-viewed-products') || '[]'
  );

  if (c_product_id && items.includes(c_product_id)) {
    items.splice(items.indexOf(c_product_id), 1);
  }
  let searchQueryString = items
    .map((item) => 'id:' + item)
    .slice(0, recentlyViewEle.data('limit'))
    .join(' OR ');

  fetch(`${recentlyViewEle.data('url')}&q=${searchQueryString}`)
    .then((response) => response.text())
    .then((text) => {
      //console.log(text);
      const html = document.createElement('div');
      html.innerHTML = text;
      const recently_products = html.querySelector('.product-grid');
      if (recently_products) {
        recentlyViewEle.removeClass('hidden');
        $('#recently-viewed-block .product-grid').html(
          recently_products.innerHTML
        );
      }
    })
    .catch((e) => {
      console.error(e);
    });
}

function footerMenuMobile() {
  $(window).width() < 990 &&
    $('.footer .footer-block .footer-block__details-content').hide();
  $(document).on('click', '.footer h2.footer-block__heading', function (e) {
    if ($(window).width() < 990) {
      const isHava = $(this).hasClass('open');
      if (!isHava) {
        $(this)
          .addClass('open')
          .siblings('.footer-block__details-content')
          .show();
      } else {
        $(this)
          .removeClass('open')
          .siblings('.footer-block__details-content')
          .hide();
      }
    }
  });

  if ($(window).width() < 990) {
    $('.footer .footer-block .footer-block__details-content').hide();
    const testName = $('.footer .footer-block .footer-block__heading span');
    for (let i = 0; i < testName.length; i++) {
      if ($(testName[i]).text() == 'Support') {
        $(testName[i])
          .parents('.footer-block__heading')
          .siblings('.footer-block__details-content')
          .show();
        $(testName[i]).parents('.footer-block__heading').addClass('open');
      }
    }
  }

  const productDom = $(
    '.product .product__info-wrapper .product__accordion summary h2.accordion__title'
  );
  for (let i = 0; i < productDom.length; i++) {
    const textName = $(productDom[i]).text();
    if (textName.indexOf('Dimensions & Specifications') > -1) {
      $(productDom[i]).parents('details').find('.descriptionOuterBox').show();
      $(productDom[i])
        .parents('details')
        .find('.accordion__content')
        .css('max-height', '600px');
    }
    if (textName.indexOf('Quick Know') > -1) {
      $(productDom[i]).parents('summary').click();
    }
  }
}
function showTotalData(data, flag) {
  const moneyFormat = getSafeMoneyFormat();
  const shippingFee = Number(window.shipping_fee) || 0;
  if (data.items.length <= 0) {
    return;
  }
  if (data.total_discount > 0) {
    var code_list = [];
    if (data.cart_level_discount_applications.length > 0) {
      data.cart_level_discount_applications.forEach((i) => {
        if (typeof i.discount_application != 'undefined') {
          code_list.push(i.discount_application.title.toUpperCase());
        } else if (typeof i.title != 'undefined') {
          code_list.push(i.title.toUpperCase());
        }
      });
    } else if (data.discount_codes.length > 0) {
      data.discount_codes.forEach((i) => {
        if (i.applicable == true) {
          if (typeof i.code != 'undefined') {
            code_list.push(i.code.toUpperCase());
          } else if (typeof i.title != 'undefined') {
            code_list.push(i.title.toUpperCase());
          }
        }
      });
    }
    var code_html = '';
    code_list.forEach((item_c) => {
      code_html +=
        '<span class="applied-discount-code-wrapper" style="display: inline-flex;" data="' +
        item_c +
        '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" aria-hidden="true"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005v-.005Z"></path></svg><span class="applied-discount-code-value" data="' +
        item_c +
        '">' +
        item_c +
        '</span><button type="button" id="clear-discount-btn" data="' +
        item_c +
        '" aria-label="Remove discount code ' +
        item_c +
        '">X</button></span>';
    });
    $('.applied-discount-code').html(code_html);
    $('.applied-discount-code2').removeClass('hide');
    $('.cart-items-subtotal').html(
      Shopify.formatMoney(data.items_subtotal_price, moneyFormat)
    );
    $('.cart-items-discount').html(
      '-' + Shopify.formatMoney(data.total_discount, moneyFormat)
    );
    let cart_total = data.total_price + shippingFee;
    $('.cart_total_money').html(
      Shopify.formatMoney(data.total_price, moneyFormat)
    );
  } else {
    $('.applied-discount-code').html('');
    $('.applied-discount-code2').addClass('hide');
    if (flag) {
      $('.discount-code-error').html('Please Enter Valid Coupon Code.');
    }
    $('.cart-items-subtotal').html(
      Shopify.formatMoney(data.items_subtotal_price, moneyFormat)
    );
    $('.cart-items-discount').html(
      '-' + Shopify.formatMoney(data.total_discount, moneyFormat)
    );
    let cart_total = data.total_price + shippingFee;
    $('.cart_total_money').html(Shopify.formatMoney(cart_total, moneyFormat));
  }
  try {
    if ($('#cart-items-discount-save-price').length > 0) {
      var cart_items_discount_save_price = parseInt(
        $.trim($('#cart-items-discount-save-price').attr('value'))
      );
      if (cart_items_discount_save_price > 0) {
        data.total_discount =
          data.total_discount + cart_items_discount_save_price;
      }
    }
  } catch (e) {
    console.log(e);
  }
  if ($('.cart_total_savings').length > 0) {
    if (data.total_discount > 0) {
      $('.cart_total_savings').html(
        'Savings: ' + Shopify.formatMoney(data.total_discount, moneyFormat)
      );
      $('.cart_total_savings').removeClass('hide');
    } else {
      $('.cart_total_savings').addClass('hide');
    }
  }
}

let shippingRateRequestInFlight = false;
function requestShippingRate() {
  if (shippingRateRequestInFlight) {
    return;
  }
  shippingRateRequestInFlight = true;
  const moneyFormat = getSafeMoneyFormat();
  fetch('/cart/shipping_rates.json', {
    method: 'POST',
    body: JSON.stringify({
      shipping_address: {
        zip: '77523',
        country: 'United States',
        province: 'Texas',
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(function (parsedState) {
      if (
        parsedState &&
        parsedState.shipping_rates &&
        parsedState.shipping_rates.length > 0 &&
        parsedState.shipping_rates[0].price >= 0
      ) {
        window.shipping_fee = parsedState.shipping_rates[0].price * 100;
        const shippingFee = Number(window.shipping_fee) || 0;
        var cart_shipping_fee_money = document.querySelectorAll(
          '.cart_shipping_fee_money'
        );
        for (var i = 0; i < cart_shipping_fee_money.length; i++) {
          cart_shipping_fee_money[i].innerHTML = Shopify.formatMoney(
            shipping_fee,
            moneyFormat
          );
          cart_shipping_fee_money[i].style = 'opacity: 1';
        }
        let cart_total = 0;
        if ($('.template-cart').length > 0) {
          cart_total =
            parseInt($('.cart__footer .cart_total_money').attr('data-price')) +
            shipping_fee;
        } else {
          cart_total =
            parseInt($('.cart_total_money').attr('data-price')) + shipping_fee;
        }
        $('.cart_total_money').html(
          Shopify.formatMoney(cart_total, moneyFormat)
        );
      }
    })
    .catch((e) => console.error(e))
    .finally(function () {
      shippingRateRequestInFlight = false;
    });
}

let throttledGetShippingRate =
  typeof throttle === 'function'
    ? throttle(requestShippingRate, 1000)
    : requestShippingRate; // 节流
function getShippingRate() {
  throttledGetShippingRate();
}

function clearDiscount(current_code) {
  $('.discount-code-error').html('');
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    if ($(this).attr('data') == current_code) {
      $(this).remove();
    }
  });
  var code_arr = [];
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    code_arr.push($(this).attr('data'));
  });
  if (code_arr.length > 0) {
    var code_temp = code_arr.join(',');
  } else {
    var code_temp = 'none';
  }
  $('.enj-minicart-ajax .total-info-order .cart-items-subtotal').html('');
  $('.enj-minicart-ajax .total-info-order .cart-items-discount').html('');
  $('.enj-minicart-ajax .prod').addClass('noDiscount');
  /*fetch("/discount/CLEAR").then(function(data){*/
  fetch('/checkout?discount=' + code_temp).then(function (data) {
    fetch('/cart.js', {})
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        showTotalData(data, 0);
      });
  });
}
function applyDiscount(code) {
  if ($.trim(code).length <= 0) {
    return;
  }
  code = code.toUpperCase();
  var code_arr = [];
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    code_arr.push($(this).attr('data'));
  });
  if (code_arr.indexOf(code) !== -1) {
    return;
  }
  code_arr.push(code);
  var code_temp = code_arr.join(',');
  $('.discount-code-error').html('');
  $('.apply-discount-btn')
    .addClass('btn--loading')
    .html("Apply <div class='loader'></div>");
  $('.apply-discount-btn').css('pointerEvents', 'none');
  /*fetch(`/discount/${code_temp}`)*/
  fetch('/checkout?discount=' + code_temp)
    .then(function () {
      // After the discount code has been applied, force the cart to update so the discount is visible
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: {},
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          showTotalData(data, 1);
          $('.apply-discount-btn').html('Apply');
        });
    })
    .then(function () {
      // 更新购物车显示（如果需要）
      console.log('Please Enter Valid Coupon Code.');
    })
    .catch(function (error) {
      console.error('Error--:', error);
    })
    .finally(function (params) {
      $('.apply-discount-btn').removeClass('btn--loading').html('Apply');
      $('.apply-discount-btn').css('pointer-events', 'all');
    });
}

function getSafeMoneyFormat() {
  if (window.settings_new && window.settings_new.moneyFormat) {
    return window.settings_new.moneyFormat;
  }
  if (window.money_format) {
    return window.money_format;
  }
  return '${{amount}}';
}

/* judge reviews */
function showProductThumbnail(ele_obj, product_info) {
  if (
    ele_obj &&
    ele_obj.length &&
    product_info &&
    typeof product_info.featured_image != 'undefined' &&
    product_info.featured_image
  ) {
    let img_html_str =
      '<img src="' +
      product_info.featured_image +
      '&width=60' +
      '" alt="" title="" class="judge-reviews-carousel-product-img" loading="lazy">';
    $(ele_obj)
      .find('.jdgm-carousel-item__product-title')
      .css('cssText', 'display: block !important')
      .before(img_html_str);
  }
}
